/**
 * @class FormFilter
 * @classdesc Filters target items when input in the form changes.
 */
class FormFilter {
  constructor(el, options) {
    this.currentFilters = {};
    
    Object.assign(this, {
      form: el,
      target: $(this).data('formfilter-target'),
      submit: false,
      visibleClass: 'formfilter-result-visible',
      invisibleClass: 'formfilter-result-invisible',
      noResultsSelectors: '.formfilter-no-results',
      inputs: [
        'input',
        'select',
        'text',
      ],
    }, options);

    this.setEvents();
    this.setTargetClasses();
    this.setCheckedInputsAsFilters();

    const self = this;

    $(this.inputs.join(','), this.form).on('change', (event) => {
      this.addToFilters(event.currentTarget);
      this.filterTargets(event);

      const visibleItems = $(`${self.target}.formfilter-result-visible`);

      if (visibleItems.length === 1
        && parseInt(visibleItems[0].dataset.id, 10) === self.exception) {
        $(this.noResultsSelectors).show();
      } else {
        $(this.noResultsSelectors).hide();
      }
    });
  }

  setEvents() {
    this.events = {
      show: this.createNewEvent('formfilter.show'),
      hide: this.createNewEvent('formfilter.hide'),
    };
  }

  // IE compatiblity. new Event() not supported in IE.
  createNewEvent(eventName) { /* eslint-disable-line class-methods-use-this */
    let event;
    if (typeof(Event) === 'function') { /* eslint-disable-line space-unary-ops */
      event = new Event(eventName);
    } else {
      event = document.createEvent('Event');
      event.initEvent(eventName, true, true);
    }
    return event;
  }

  setTargetClasses() {
    $(this.target).addClass(this.visibleClass);
  }

  setCheckedInputsAsFilters() {
    const inputs = $(this.inputs.join(','), this.form);

    inputs.each((index, input) => {
      if ($(input).is(':checked')) {
        this.addToFilters(input);
      }
    });
  }

  /**
   * Loops through the set filters and the targets
   * and figures out what targets to hide and show
   */
  filterTargets() {
    $(this.target).each((index, el) => {
      if (Object.keys(this.currentFilters).length) {
        let isMatchForAll = true;

        Object.entries(this.currentFilters).forEach(([filterKey, filterValues]) => {
          const targetValue = $(el).data(`formfilter-key-${filterKey}`);
          const targetValues = targetValue.toString().split(', ');
          const isMatch = filterValues.filter(value => targetValues.includes(value));

          if (!isMatch.length) {
            isMatchForAll = false;
          }
        });

        if (this.exception === $(el).data('id')) {
          return;
        }

        if (isMatchForAll) {
          el.dispatchEvent(this.events.show);
          $(el)
            .removeClass(this.invisibleClass)
            .addClass(this.visibleClass);
        } else {
          el.dispatchEvent(this.events.hide);
          $(el)
            .removeClass(this.visibleClass)
            .addClass(this.invisibleClass);
        }
      } else {
        $(el)
          .removeClass(this.invisibleClass)
          .addClass(this.visibleClass)
          .show()
          .css('opacity', 1);
      }
    });
  }

  /**
   * Checks to see if the passed input
   * should be added to the filters, then adds it.
   * 
   * @param {HTMLElement} input
   * @todo
   *  The `currentFilter` and `this.currentFilters[inputName]` are used interchangably here,
   *  it should be worked out which one to use, and why.
   * 
   * @todo
   *  Divide this function up into multiple functions to make the code cleaner
   */
  addToFilters(input) {
    const inputName = $(input).attr('name');
    const values = input.value.split(/,\s*/);
    let currentFilter = this.currentFilters[inputName];

    // Check if the filter already exists, create it if it isn't there
    if (!currentFilter) {
      this.currentFilters[inputName] = [];
      currentFilter = this.currentFilters[inputName];
    }

    // If input is valid and the input hasn't been added to the filters, add it.
    values.forEach((value) => {
      if (this.constructor.isValidInput(input) && !this.currentFilters[inputName].includes(value)) {
        if (input.type === 'checkbox' || input.type === 'radio') {
          currentFilter.push(value);
        } else {
          currentFilter[0] = value;
        }
      } else {
        // Set the current filters without the current input value
        if (currentFilter.includes(value)) {
          const filtered = this.currentFilters[inputName].filter(item => item !== value);
          this.currentFilters[inputName] = filtered;
        }

        // Reset the current filter if the user chooses to
        if (value === '') {
          delete this.currentFilters[inputName];
        }

        if (this.currentFilters[inputName] && this.currentFilters[inputName].length === 0 && !input.hasAttribute('data-formfilter-required')) {
          delete this.currentFilters[inputName];
        }
      }
    });
  }

  /**
   * Checks to see if the passed input
   * has a value, or, if it's a checkable input, is checked
   * 
   * @param {HTMLElement} input 
   */
  static isValidInput(input) {
    let valid = false;

    if (input.type === 'checkbox' || input.type === 'radio') {
      valid = input.checked;
    } else if (input.value.length) {
      valid = input.value.length;
    }
    
    return valid;
  }
}

/** 
 * jQuery plugin
 * 
 * @example $('.my-form').formFilter({target: '.my-target-element'});
 */
$.fn.formFilter = function init(options) {
  return new FormFilter(this, options);
};
